module.exports = __webpack_public_path__ + "static/media/sf-landmark-4.1f68523e.png";